import {reactive} from "vue";
import i18n from "../../i18n/i18n";
//@ts-ignore
import { dataTriggerPolicyAnalogBandSideHtml, dataTriggerPolicyConnectionSideHtml, dataTriggerPolicyOnChangeSideHtml, dataTriggerPolicyOnLevelSideHtml } from "../../../static/docs/brands/corvina";
export default reactive({
  sideHelpOnLevel: {} as Record<string, string>,
  sideHelpAnalogBand: {} as Record<string, string>,
  sideHelpConnection: {} as Record<string, string>,
  sideHelpOnChanged: {} as Record<string, string>,
  async fetchHelpData(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    console.log("Fetching help data for language:", lang);

    try {
      this.sideHelpOnLevel[lang] = await dataTriggerPolicyOnLevelSideHtml(lang);
      this.sideHelpAnalogBand[lang] = await dataTriggerPolicyAnalogBandSideHtml(lang);
      this.sideHelpConnection[lang] = await dataTriggerPolicyConnectionSideHtml(lang);
      this.sideHelpOnChanged[lang] = await dataTriggerPolicyOnChangeSideHtml(lang);
    } catch (error) {
      console.warn("No help data found for language:", lang, error);
      this.sideHelpOnLevel[lang] = await dataTriggerPolicyOnLevelSideHtml("en"); // Fallback to English if fetch fails
      this.sideHelpAnalogBand[lang] = await dataTriggerPolicyAnalogBandSideHtml("en"); // Fallback to English if fetch fails
      this.sideHelpConnection[lang] = await dataTriggerPolicyConnectionSideHtml("en"); // Fallback to English if fetch fails
      this.sideHelpOnChanged[lang] = await dataTriggerPolicyOnChangeSideHtml("en"); // Fallback to English if fetch fails
    }
  },
  getLocaleOnLevelHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.sideHelpOnLevel[lang] || "No help available";
  },
  getLocaleOnChangedHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.sideHelpOnChanged[lang] || "No help available";
  },
  getLocaleConnectionHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.sideHelpConnection[lang] || "No help available";
  },
  getLocaleAnalogBandHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.sideHelpAnalogBand[lang] || "No help available";
  }
});

function tryGetLangFromLocale(locale: string): string {
  if (locale.length === 2) return locale.toLowerCase();
  return locale?.split('-')?.[0]?.toLowerCase() || "en";
}